import styled from "styled-components";

export const BackStyle = styled.div`
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.2);
  position: fixed;
  left: 0;
  top: 0;
  z-index: 5000;
  display: flex;
  justify-content: center;
  align-items: center;
`;
